import { Component, OnInit } from '@angular/core';
import { TextService } from 'src/app/services/text-service.service';

@Component({
  selector: 'app-themes',
  templateUrl: './themes.component.html',
  styleUrls: ['./themes.component.css']
})
export class ThemesComponent implements OnInit {

  constructor(public textDefinitions: TextService) { }

  ngOnInit() {
  }

}
